import { createFileRoute, Navigate } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { EmployeesPage } from 'src/modules/automations/components/pages/employees/employees.page';
import { employeesSearchSchema } from 'src/modules/automations/schemas/employees/employees.schema';
import Loading from 'src/modules/shared/components/atoms/loading';
import { useHasPermissions } from 'src/modules/shared/hooks/auth';
import { AutomationEmployeePermission } from 'src/modules/shared/types/permissions.type';

export const Route = createFileRoute('/employees/')({
  component: EmployeesLayoutComponent,
  validateSearch: (search) => employeesSearchSchema.parse(search),
});

function EmployeesLayoutComponent() {
  const { hasPermission: canUpdateEmployee, loading } = useHasPermissions(
    AutomationEmployeePermission.Update
  );

  if (loading) {
    return <Loading size="lg" />;
  }

  if (!canUpdateEmployee) {
    return <Navigate to="/" />;
  }

  return (
    <AuthenticateRoute>
      <EmployeesPage />
    </AuthenticateRoute>
  );
}
